import "./Header.css";
import Navbar from "./Navbar";
import logo from "./logo-lion.svg";

import { Link } from "react-router";

function Header() {
  return (
    <header className="header dark-bg">
      <div className="header-content">
        <Link to="/" className="logo">
          <img src={logo} />
          <h1>Aquitaine Capital</h1>
        </Link>
        <Navbar />
      </div>
    </header>
  );
}

export default Header;
